import { LadiesMain } from "@modules/global/ladies-main.ts"
import { getQueryParameter, removeQueryParameter, setQueryParameter } from "@modules/util/query-parameter"
import { updateUrl } from "@modules/util/url"
import {
    getOpenSearchTextButton,
    getSearchTextElement,
    searchTextButtonElement,
    searchTextButtonIcon,
} from "../../global/dom.ts"
import { getLocation } from "../../location/location"
import { isMobile, isPC } from "../../util/device"
import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { fetchApiWithAllFilters, fetchApiWithAllFiltersDebounced } from "../api"
import { openFilterTab } from "./filter-tabs"
import { setShowResultsButton, setShowResultsButtonLoading } from "./set-show-results-button"

export function updateSearchTextInDom() {
    const text = getQueryParameter("suchtext") || ""
    const searchTextElement = getSearchTextElement()
    if (searchTextElement) {
        searchTextElement.value = text
        if (isMobile()) {
            searchTextElement.placeholder = `\uf4a5 Suche in ${getLocation().name}`
        }
    }
}

export function enableSearchTextButtonInDom() {
    searchTextButtonElement()?.removeAttribute("disabled")
    const icon = searchTextButtonIcon()
    if (icon) icon.style.fill = "#333"
}

export function disableSearchTextButtonInDom() {
    searchTextButtonElement()?.setAttribute("disabled", "")
    const icon = searchTextButtonIcon()
    if (icon) icon.style.fill = "#ccc"
}

export function enableSearchTextLoadingInDom() {
    getSearchTextElement()?.classList.add("ui-autocomplete-loading")
    getSearchTextElement()?.setAttribute("disabled", "")
    disableSearchTextButtonInDom()
}

export function disableSearchTextLoadingInDom() {
    getSearchTextElement()?.classList.remove("ui-autocomplete-loading")
    getSearchTextElement()?.removeAttribute("disabled")
    enableSearchTextButtonInDom()
}

async function ongetSearchTextElementEnter() {
    if (!getSearchTextElement()?.reportValidity()) {
        return
    }
    const searchTextElement = getSearchTextElement()
    if (!searchTextElement) {
        return
    }
    enableSearchTextLoadingInDom()
    setQueryParameter("suchtext", searchTextElement.value)
    afterFilterApiFetched(await fetchApiWithAllFilters())
    disableSearchTextLoadingInDom()
}

function fetchFiltersAfterSearchTextUpdate() {
    setShowResultsButtonLoading()
    fetchApiWithAllFiltersDebounced((result) => setShowResultsButton(result.advertCount))
}

if (isPC()) {
    searchTextButtonElement()?.addEventListener("click", ongetSearchTextElementEnter)
    getSearchTextElement()?.addEventListener("keyup", async (event: KeyboardEvent) => {
        if (event.key === "Enter") {
            ongetSearchTextElementEnter()
        }
    })
    getOpenSearchTextButton()?.addEventListener("click", (event: MouseEvent) => {
        event.preventDefault()

        //searchIcon not in /sex-anzeigen clicked
        if (!getSearchTextElement()) {
            window.location.href = getOpenSearchTextButton()?.getAttribute("href") || "/sex-anzeigen#suchtext"
        }

        getSearchTextElement()
    })
} else {
    // mobile only update count
    getSearchTextElement()?.addEventListener("input", async () => {
        const searchTextElement = getSearchTextElement()
        if (!searchTextElement?.reportValidity()) {
            return
        }
        if (!searchTextElement) {
            return
        }
        setQueryParameter("suchtext", searchTextElement.value)
        fetchFiltersAfterSearchTextUpdate()
    })
    // help me pls. old template random form submit
    $(getSearchTextElement()?.closest("form"))?.submit(false)
    // mobile remove searchtext button
    document.querySelector("#button-empty-search-text")?.addEventListener("click", async () => {
        removeQueryParameter("suchtext")
        updateSearchTextInDom()
        fetchFiltersAfterSearchTextUpdate()
    })
}

function focusSearchtextElement() {
    if (isMobile()) {
        $("#fltCont").modal("show")
        getSearchTextElement()?.focus()
    } else {
        window.setTimeout(() => {
            openFilterTab("general")
            getSearchTextElement()?.focus()
            const newUrl = new URL(window.location.href)
            updateUrl(newUrl.href)
        }, 0)
    }
}

enableSearchTextButtonInDom()
updateSearchTextInDom()

getOpenSearchTextButton()?.addEventListener("click", (e) => {
    e.preventDefault()
    focusSearchtextElement()
})

if ("" !== location.hash.replace("#", "")) {
    const hashtagParams = new URLSearchParams(location.hash.replace(/^#/, ""))
    for (const modalName of hashtagParams.keys()) {
        if (modalName === "suchtext") {
            focusSearchtextElement()
            LadiesMain.removeHashtagFromUrl("suchtext")
            break
        }
    }
}
